import { useState } from "react";
import { useStore, CAT_META } from "../store/Store";

// ─── POLAROID CARD ────────────────────────────────────────────────────────────
// Instant-photo aesthetic — thick white bottom border, faint paper shadow,
// a slight tilt on hover, and a handwritten-style price tag. Playful and
// personal, unlike anything else in the set.
export default function PolaroidCard({ p, onNav, accent }) {
  const { dispatch, wish, toggleWish, notify } = useStore();
  const [hovered, setHovered] = useState(false);
  const meta = CAT_META[p.category] || { emoji:"👗" };
  const disc = Math.round((1 - p.price / p.mrp) * 100);
  const wished = wish.includes(p.id);

  const addCart = (e) => {
    e.stopPropagation();
    dispatch({ type:"ADD", p:{ ...p, sc:p.colors?.[0]||"Default", ss:p.sizes?.[0]||"Free" } });
    notify(`${p.name} added!`);
    if (navigator.vibrate) navigator.vibrate(50);
  };

  return (
    <div
      onClick={()=>onNav("product", p.id)}
      onMouseEnter={()=>setHovered(true)}
      onMouseLeave={()=>setHovered(false)}
      style={{
        background:"white", padding:"10px 10px 0", cursor:"pointer",
        boxShadow: hovered ? "0 20px 34px rgba(0,0,0,0.18)" : "0 6px 16px rgba(0,0,0,0.1)",
        transform: hovered ? "rotate(0deg) translateY(-4px)" : "rotate(-1.5deg)",
        transition:"all 0.35s ease",
      }}>
      <div style={{ position:"relative", height:250, background:meta.light||"#fafafa", overflow:"hidden", display:"flex", alignItems:"center", justifyContent:"center" }}>
        {p.img
          ? <img src={p.img} alt={p.name} style={{ width:"100%", height:"100%", objectFit:"cover", objectPosition:"top" }} loading="lazy"/>
          : <div style={{ fontSize:44, opacity:0.25 }}>{meta.emoji}</div>
        }
        {disc > 0 && (
          <span style={{ position:"absolute", top:8, right:8, background:accent, color:"white", fontSize:9, fontWeight:800, padding:"3px 9px", borderRadius:4, transform:"rotate(4deg)" }}>
            {disc}% OFF
          </span>
        )}
        <button onClick={e=>{ e.stopPropagation(); toggleWish(p.id); if(navigator.vibrate)navigator.vibrate(30); }}
          style={{ position:"absolute", top:8, left:8, background:"white", border:"none", borderRadius:"50%", width:26, height:26, fontSize:12, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", boxShadow:"0 2px 8px rgba(0,0,0,0.18)" }}>
          {wished ? "❤️" : "🤍"}
        </button>
      </div>
      <div style={{ padding:"12px 4px 16px", textAlign:"center" }}>
        <div style={{ fontFamily:"'Playfair Display',serif", fontStyle:"italic", fontSize:14, color:"#1a1a2e", marginBottom:6, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{p.name}</div>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:10 }}>
          <span style={{ fontSize:14, fontWeight:900, color:accent }}>₹{p.price?.toLocaleString("en-IN")}</span>
          {p.stock > 0 && (
            <button onClick={addCart} style={{ background:"none", border:`1.5px solid ${accent}`, color:accent, padding:"3px 11px", borderRadius:20, fontSize:10, fontWeight:800, cursor:"pointer" }}>+ Add</button>
          )}
        </div>
      </div>
    </div>
  );
}
